import { FinanceService } from "../../core/services/FinanceService";
import { useState, useEffect } from 'react';
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import { ModalConfirm } from "../theme/Component/ModalConfirm";
import { Modal } from "../theme/Component/Modal";
import { SelectBudgetID } from "../admin/configuracion/BudgetID/SelectBudgetID";
import { ListMenu } from "../theme/Component/ListMenu";
import { useDashboardStore } from "../pages/hooks/useDashboardStore";
import { Singleton } from "../../core/services/Singleton";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import { InputMoney } from "../theme/Input/InputMoney";
import { ITEM_CONSOLIDATOR } from "../Constants";

interface Props {
    adquisitionItem: any;
    iDBudgetIDType: number;
    CanModify?: number;
    estimateValue?: number;
    onChange?: any;
    rolModify?: number;
}

export const AdquisitionItemBudgetID = ({ adquisitionItem, iDBudgetIDType, CanModify, estimateValue, onChange, rolModify }: Props) => {

    const service = new FinanceService();
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const idBean = "IDAdquisitionItemBudgetID";

    useEffect(() => {
        getLista();
    }, [adquisitionItem.IDAdquisitionItem])

    const getLista = () => {
        _single.spinner(true);
        service.getAdquisitionItemBudgetIDCatalog(adquisitionItem.IDAdquisitionItem).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);

                }
                _single.spinner(false);
            }
        );
    }

    const setRow = (b: any) => {
        setBean(b);
    }
    const agregarItem = () => {
        let b = {
            IDLnBudgetID: 0,

            EstimatedValue: 0,
            Description: '',
            IDEmployee: single.getAccountID(),
            Since: single.getCurrenDate(),
            IDAdquisitionItem: adquisitionItem.IDAdquisitionItem,
        }
        setBean(b);
        setModal({ ...modal, ['view']: true, 'name': 'Agregar Rubro' });
    }
    const updateItem = () => {

        setModal({ ...modal, ['view']: false });

        setLoading(true);
        service.updateAdquisitionItemBudgetID(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                if (onChange)
                    onChange(true);
            }
        );

    }
    const editarItem = () => {
        setModal({ ...modal, ['view']: true, 'name': 'Editar Rubro' });

    }
    const eliminarItem = () => {
        setLoading(true);
        service.deleteAdquisitionItemBudgetID(bean[idBean]).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getLista();
                }
                single.delete(bean[idBean], bean);
            }
        );
        setModalConfirm({ ...modalConfirm, ['view']: false });
    }

    const head = [
        { title: 'ID', property: idBean, visible: false, mask: MASK_NUMBER },
        { title: 'Vigencia', property: 'Year', mask: MASK_NUMBER },
        { title: 'Codigo Rubro', property: 'BudgetIDStr' },
        { title: 'Nombre Rubro', property: 'BudgetIDName' },
        { title: 'Valor Estimado', property: 'BudgetEstimatedValue', mask: MASK_MONEY },
        { title: 'Tipo', property: 'BudgetTypeName' },
        { title: 'Recurso', property: 'BudgetResourceName' },
        { title: 'Fuente', property: 'BudgetSourceName' },
        { title: 'PI', property: 'PIValue', mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY },
        { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY },
        { title: 'RP', property: 'RPValue', mask: MASK_MONEY, visible: true },
        { title: 'RRP', property: 'RRPValue', mask: MASK_MONEY, visible: true },
        { title: 'OB', property: 'OBValue', mask: MASK_MONEY, visible: true },
        // { title: 'Funcionario', property: 'EmployeeName', visible: false },
        // { title: 'Observaciones', property: 'Description', visible: false },
    ]

    const iconButtons = [
        { nombre: 'Agregar', visible: rolModify == ITEM_CONSOLIDATOR || ((CanModify === 30 || CanModify === 31 || CanModify === 27 || CanModify === 9 || CanModify === 4 || CanModify == null)), icono: 'ri-file-add-line', evento: agregarItem }
    ]
    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Editar', icono: 'ri-edit-2-line', visible: rolModify == ITEM_CONSOLIDATOR || ((CanModify === 30 || CanModify === 31 || CanModify === 27 || CanModify === 9) &&
                    ![bean.PIValue, bean.CCValue, bean.CDPValue, bean.RCDPValue].some(value => value) &&
                    ![bean.IDBudgetSource, bean.IDBudgetResource].some(value => value)), evento: editarItem
            },
            {
                titulo: 'Eliminar', icono: 'ri-eraser-line', visible: rolModify == ITEM_CONSOLIDATOR || (

                    (CanModify === 30 || CanModify === 31 || CanModify === 27 || CanModify === 9) &&
                    ![bean.PIValue, bean.CCValue, bean.CDPValue, bean.RCDPValue].some(value => value) &&
                    ![bean.IDBudgetSource, bean.IDBudgetResource].some(value => value)
                ), evento: () => { setModalConfirm({ ...modalConfirm, ['view']: true }) }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <>
            <div className="row mt-4">
                <div className="col-md-12">
                    <BasicTable iconButtons={iconButtons} listButtons={listaBotones()} head={head} body={lista} rowSet={setRow}></BasicTable>

                    <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                        {bean.Description}
                    </ModalConfirm>

                    <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectBudgetID edit={false} idBudgetID={bean.IDLnBudgetID} tipoPresupuesto={iDBudgetIDType} onChange={(e: any) => {
                                    setBean({ ...bean, "IDLnBudgetID": e.IDLn });
                                }} />
                            </div>
                            <div className="col-md-12">
                                <InputMoney _value={bean.EstimatedValue} onChange={(e) => { setBean({ ...bean, "EstimatedValue": e }) }} _label="Valor Estimado" />
                            </div>
                            {/* <div className="col-md-6">
                                <BudgetResourceEditor label="Tipo de Recurso" idSelector={bean.IDBudgetResource} onChange={(e) => { setBean({ ...bean, "IDBudgetResource": e }) }} />
                            </div> */}
                            <div className="col-md-12">
                                <label className="form-label">Observaciones</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }}></textarea>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}